import { IRecurly } from '@/@types'

const state: IRecurly = {
  recurlyPricing: {},
  recurlyToken: '',
  recurlyTokenActionId: '',
  recurlyTokenActionResult: '',
}

export default state
